export default __webpack_public_path__ + "static/media/logo.67ac9b15.svg";